import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from '../styles.scss';
import WorkroomSelect from 'components/formElements/WorkroomSelect';
import FiltersDrawer from 'components/FiltersDrawer';
import RoleSelect from 'components/formElements/RoleSelect';
import ReactSelect from 'components/StyledSelect/react_select';
import ActiveSelect from 'components/formElements/ActiveSelect';
import { can } from '../../../../services';

const PENDING_OPTIONS = [
  { value: null, label: 'All' },
  { value: false, label: 'Confirmed' },
  { value: true, label: 'Pending' },
];

class UserFilters extends Component {

  handleFilter = (key, value) => {
    const filters = { ...this.props.filters };
    filters[key] = value;

    this.props.handleFilterChange(filters);
  }

  handleActive = value => this.handleFilter('is_active', value)
  handlePending = value => this.handleFilter('is_pending', value)
  handleWorkrooms = values => this.handleFilter('for_workrooms', values.map(v => v.value))
  handleRoles = values => this.handleFilter('for_roles', values.map(v => v.value))

  render() {
    const { filters, active, title, reset, showRoles, resource } = this.props;
    const canViewInactive = can(this.props.role, 'view_inactive', resource);
    return (
      <FiltersDrawer
        title={title}
        active={active}
        toggle={this.props.onOverlayClick}
        reset={reset}
      >
        <WorkroomSelect
          value={filters.for_workrooms}
          onChange={this.handleWorkrooms}
          className={styles.dropdown}
          key="workroom"
        />
        {showRoles && <RoleSelect
          key="role"
          className={styles.dropdown}
          onChange={this.handleRoles}
          value={filters.for_roles}
          resetValue={[]}
          placeholder="All Roles"
          multi
        />}
        {canViewInactive && <ActiveSelect
          key="active"
          className={styles.dropdown}
          value={filters.is_active}
          onChange={this.handleActive}
        />}
        <ReactSelect
          key="pending"
          className={styles.dropdown}
          label="Pending Status"
          name="pending"
          placeholder="Show All"
          options={PENDING_OPTIONS}
          value={filters.is_pending}
          onChange={this.handlePending}
          simpleValue
        />
      </FiltersDrawer>
    );
  }
}

UserFilters.defaultProps = {
  showRoles: false,
};

UserFilters.propTypes = {
  handleFilterChange: PropTypes.func,
  onOverlayClick: PropTypes.func,
  filters: PropTypes.object,
  active: PropTypes.bool,
  title: PropTypes.string.isRequired,
  reset: PropTypes.func.isRequired,
  showRoles: PropTypes.bool,
  role: PropTypes.string.isRequired,
  resource: PropTypes.string.isRequired,
};

export default UserFilters;



// WEBPACK FOOTER //
// ./client/app/shared/components/Filters/UserFilters/index.jsx